module.exports = __webpack_public_path__ + "static/media/trim-ph-o.231dfcf1.png";